import request from '@/utils/request'
import { getToken, getUserId,getType} from '@/utils/auth'

// 用户后台登录
export function loginByUsername(data) {
  return request({
    url: '/user/login/login',
    method: 'post',
    data
  })
}

// 退出登录
export function logout(data) {
  var header=getUserId()+','+getToken()+","+'system'+','+getType()
  return request({
    url: '/user/login/quit',
    headers:{Authorization:header},
    method: 'post',
    data
  })
}

// 根据id获取用户信息
export function getUserInfo(userId) {
  return request({
    url: '/user/index/getUserInfo?user_id='+userId,
    method: 'get'
  })
}


